
const digest = '743fce64740488326a213dd12c4faceed674b39bb0bf89d212827e421493ce22';
const classes = {"wrapper":"_wrapper_xvfv4_1","title":"_title_xvfv4_6","bold":"_bold_xvfv4_10"};
const css = `._wrapper_xvfv4_1 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  font-size: 14px;
}
._wrapper_xvfv4_1 ._title_xvfv4_6 {
  font-size: 12px;
  color: #6f6f6f;
}
._wrapper_xvfv4_1 ._bold_xvfv4_10 {
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  